import { render, staticRenderFns } from "./DishRate.vue?vue&type=template&id=27f8f810&"
import script from "./DishRate.vue?vue&type=script&lang=js&"
export * from "./DishRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports